//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axios from "axios"
import draggable from 'vuedraggable'

export default {
  name: 'Home',
  components: {
    draggable
  },
  data: function() {
    return {
      nextup: []
    }
  },
  computed: {
  },
  methods: {
  }
}
